import React, { useState, useEffect } from 'react';
import { Grid, useWidth, Box } from 'vindi-ds-components';

import { smallScreenStyles, largeScreenStyles } from './styles';
import Adverts from './adverts';
import Success from './success';
import FormBox from './form_box';
import { FormProvider } from './hooks/useFormData';
import gtm from '../../components/google_tag_manager/configuration_gtm';

const maxBreakpointsForAdverts = ['xl', 'lg'];

function SignUp() {
  const [isSuccess, setSuccess] = useState(false);
  const [user, setUser] = useState({});
  const styles = ['xl'].includes(useWidth()) ? largeScreenStyles : smallScreenStyles;
  const adverts = maxBreakpointsForAdverts.includes(useWidth()) ? <Adverts /> : null;

  const setSuccessState = (userObj) => {
    setSuccess(true);
    setUser(userObj);
  };

  useEffect(() => {
    gtm();
  }, []);

  if (isSuccess) return <Success user={user} />;

  return (
    <Box display='flex' justifyContent='center'>
      <Grid container style={styles.containerStyle}>
        <Grid item container style={styles.advertsStyles} lg={6}> {adverts} </Grid>
        <Grid item container style={styles.formStyles} lg={6} md={12} sm={12} xs={12}>
          <FormProvider>
            <FormBox onSuccessSubmit={setSuccessState} />
          </FormProvider>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SignUp;
